import PropTypes from "prop-types"
import EditButton from "./edit-button"
import PermissionButton from "./permission-button"

export default function ResourceMenu({ account, resource, isOpPro, setResource, setEditAnchor }) {
  return <div className="resource-menu">
    <PermissionButton {...{ account, resource, isOpPro }} />
    <EditButton {...{ account, resource, setResource, setEditAnchor }} />
  </div>
}

ResourceMenu.propTypes = {
  account: PropTypes.string.isRequired,
  resource: PropTypes.shape({
    alias: PropTypes.string.isRequired,
    shortType: PropTypes.string.isRequired,
    resourceType: PropTypes.string.isRequired,
  }),
  isOpPro: PropTypes.bool.isRequired,
  setResource: PropTypes.func.isRequired,
  setEditAnchor: PropTypes.func.isRequired,
}
